// Emoji Guess content — sourced from Mantelligence's "Emoji Riddles with Answers"
// list. The game is presenter-run, so there's no typed-answer matching: the host
// shows the emojis, teams shout their guess, and the host reveals `answer` to
// judge it. `hint` is an optional nudge; `category` just colours a small badge.
export const EMOJI_PUZZLES = [
  { emoji: '⭐️ 💸', answer: 'Starbucks', hint: 'A global coffee chain (star + bucks)', category: 'Brands' },
  { emoji: '🪑 ⬆️', answer: 'Cheer Up', hint: "Don't be sad! (chair → cheer)", category: 'Sayings' },
  { emoji: '🏠 🍭 🍬 🍫 🏠', answer: 'Home Sweet Home', hint: "There's no place like it", category: 'Sayings' },
  { emoji: '☝🏼 🔵 🌙', answer: 'Once in a Blue Moon', hint: 'Something that happens very rarely', category: 'Sayings' },
  { emoji: '😡 ⛽️ 🚗', answer: 'Madagascar', hint: 'Mad + gas + car — also an island & a movie', category: 'Places' },
  { emoji: '🕰️ 🏅 🕊️ 🐛', answer: 'The Early Bird Catches the Worm', hint: 'Reward for starting early', category: 'Sayings' },
  { emoji: '👶 🥶 ➡️', answer: "Baby, It's Cold Outside", hint: 'A wintry holiday duet', category: 'Sayings' },
  { emoji: '🐝 ↪️ 🔙', answer: 'Be Right Back', hint: 'Chat shorthand: BRB (bee + right + back)', category: 'Sayings' },
  { emoji: '🧠 ⛈️', answer: 'Brainstorm', hint: 'A sudden bright idea or a group thinking session (Brain + Storm)', category: 'Compound Words' },
  { emoji: '⏰ ✈️', answer: 'Time Flies', hint: 'A famous idiom about how quickly the day passes (Clock + Flies)', category: 'Sayings' },
  { emoji: '🐱 🌧️ 🐶', answer: 'Raining Cats and Dogs', hint: 'An idiom used when there is a massive downpour outside (Cat + Rain + Dog)', category: 'Sayings' },
  { emoji: '🚢❄️💔', answer: 'Titanic', hint: 'A tragic shipwreck (Ship + Ice + Broken Heart)', category: 'Movies' }
]
// Use code with caution.
// Would you like me to:
// 1. Generate 10 completely new acronyms like your BRB example
// 2. Convert the original 10 movie riddles into this same JSON code format
// 3. Add more entries to this specific category list


// One distinct colour per category for the badge.
export const CATEGORY_COLORS = {
  Movies: '#7c3aed',
  Characters: '#2563eb',
  Places: '#0891b2',
  Games: '#ea580c',
  Food: '#db2777',
  Sayings: '#16a34a',
  Brands: '#ca8a04',
  Sports: '#0d9488',
  Things: '#475569',
};
